"use client";

import { EpisodeModel } from "@api/models";
import { logError } from "@lib/logger";
import { controlMissionToast } from "@lib/utils";
import { useToast } from "app/hooks";
import { GLOBALS } from "config";
import Image from "next/image";

export function SeriesShareButton({ episode }: { episode: EpisodeModel }) {
  const series = episode.series;
  const shareUrl = `${GLOBALS.HOME_URL}/episodes/${episode.id}`;
  const shareText = `${series.name} ${GLOBALS.SHARE_HASHTAG} ${GLOBALS.SHARE_USER}`;

  const { pushToast } = useToast();

  const handleShare = () => {
    fetch(`/api/series/${series.id}/share`, {
      method: "POST",
    })
      .then(async (res) => {
        controlMissionToast((await res.json()).missions, pushToast);
      })
      .catch(() => {
        logError("server error: series share");
      });
  };
  return (
    <a
      href={`https://x.com/intent/tweet?url=${shareUrl}&text=${encodeURIComponent(
        shareText,
      )}&original_referer=${shareUrl}`}
      target="_blank"
      className="ep-detail-react-item"
      onClick={() => handleShare()}
    >
      <span>
        <Image
          src="/images/icons/x.svg"
          width={35}
          height={35}
          className="ep-detail-react-item-logo"
          alt="ポストで応援"
        />
      </span>
      <span>ポストで応援</span>
    </a>
  );
}
